import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAuditLogs } from '../../store/auditLogs';

function AuditLogs() {
  const dispatch = useDispatch();
  const logs = useSelector((state) => state.auditLogs.logs);
  const sessionUser = useSelector(state => state.session.user);
  const [selectedLog, setSelectedLog] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    dispatch(fetchAuditLogs());
  }, [dispatch]);

  if (!sessionUser?.is_admin) {
    return <div className="p-5 text-3xl">Unauthorized</div>;
  }

  const formatTimestamp = (timestamp) => {
    return new Date(timestamp).toLocaleString();
  };

  const getActionColor = (action) => {
    switch (action) {
      case 'CREATE':
        return 'text-green-600';
      case 'UPDATE':
        return 'text-blue-600';
      case 'DELETE':
        return 'text-red-600';
      default:
        return 'text-gray-600';
    }
  };

  const handleShowDetails = (e, log) => {
    e.stopPropagation();
    setSelectedLog(log);
    setShowModal(true);
  };

  const ChangeDetailsModal = () => {
    if (!selectedLog) return null;

    const changesObj = typeof selectedLog.changed_fields === 'string'
      ? JSON.parse(selectedLog.changed_fields)
      : selectedLog.changed_fields;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-8 max-w-2xl w-full max-h-[80vh] overflow-y-auto">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-3xl font-bold text-blue-600">Change Details</h2>
            <button
              onClick={() => setShowModal(false)}
              className="text-gray-500 hover:text-gray-700 text-2xl"
            >
              ✕
            </button>
          </div>

          <div className="mb-4">
            <p className="text-2xl mb-2">
              <span className="font-medium">Timestamp:</span> {formatTimestamp(selectedLog.timestamp)}
            </p>
            <p className="text-2xl mb-2">
              <span className="font-medium">Table:</span> {selectedLog.table_name}
            </p>
            <p className="text-2xl mb-2">
              <span className="font-medium">Record ID:</span> {selectedLog.record_id}
            </p>
            <p className="text-2xl mb-2">
              <span className={`font-medium ${getActionColor(selectedLog.action)}`}>
                Action: {selectedLog.action}
              </span>
            </p>
          </div>

          <div className="border-t pt-4">
            <h3 className="text-2xl font-medium mb-4">Changes:</h3>
            {Object.entries(changesObj).map(([key, value]) => (
              <div key={key} className="mb-4 bg-gray-50 p-4 rounded-lg">
                <p className="text-2xl">
                  <span className="font-medium">{key}:</span>{' '}
                  {typeof value === 'object'
                    ? <pre className="whitespace-pre-wrap text-2xl mt-2">{JSON.stringify(value, null, 2)}</pre>
                    : String(value)
                  }
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="p-5">
      <h1 className="text-6xl font-bold mb-6 text-center text-blue-600">Audit Logs</h1>
      <div className="loadTrailer">
        <div className="loadTrailer_header grid-cols-[1fr_1fr_1fr_1fr_1fr_2fr]">
          <div className="text-2xl">Timestamp</div>
          <div className="text-2xl">User Performed Changes</div>
          <div className="text-2xl">Table</div>
          <div className="text-2xl">Record ID</div>
          <div className="text-2xl">Action</div>
          <div className="text-2xl">Changes</div>
        </div>
        {logs.map((log) => (
          <div
            key={log.id}
            className="grid-row grid-cols-[1fr_1fr_1fr_1fr_1fr_2fr] border-2 border-gray-200 hover:shadow-xl
              hover:bg-blue-100 hover:border-blue-500 hover:scale-[1.02]
              transition-all duration-200 cursor-pointer"
          >
            <div className="text-2xl">{formatTimestamp(log.timestamp)}</div>
            <div className="text-2xl">{log.user_alpha_code || 'Unknown'}</div>
            <div className="text-2xl">{log.table_name}</div>
            <div className="text-2xl">{log.record_id}</div>
            <div className={`text-2xl font-medium ${getActionColor(log.action)}`}>
              {log.action}
            </div>
            <div className="text-2xl p-2">
              {log.changed_fields ? (
                <button
                  onClick={(e) => handleShowDetails(e, log)}
                  className="text-blue-600 hover:text-blue-800 text-2xl"
                >
                  Show Details
                </button>
              ) : (
                <span className="text-gray-500 italic text-2xl">No changes</span>
              )}
            </div>
          </div>
        ))}
      </div>
      {showModal && <ChangeDetailsModal />}
    </div>
  );
}

export default AuditLogs;
